import { render, staticRenderFns } from "./comp_UpsellProductCard.vue?vue&type=template&id=4663c54a&scoped=true"
import script from "./comp_UpsellProductCard.vue?vue&type=script&lang=js"
export * from "./comp_UpsellProductCard.vue?vue&type=script&lang=js"
import style0 from "./comp_UpsellProductCard.vue?vue&type=style&index=0&id=4663c54a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4663c54a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
